import { chartDemo } from '../../../demos/charts.js';

export const demoFunc = () => chartDemo('area');
